import { useState, useEffect } from 'react';
"use strict";
function useIsTouchDevice() {
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  useEffect(() => {
    function onResize() {
      setIsTouchDevice("ontouchstart" in window || navigator.maxTouchPoints > 0);
    }
    window.addEventListener("resize", onResize);
    onResize();
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  return isTouchDevice;
}
export { useIsTouchDevice };
//# sourceMappingURL=useIsTouchDevice.mjs.map
